import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";

interface FieldGroupProps {
  label: string;
  labelVariant?: typeof Typography.prototype.variant;
  description?: string;
  required?: boolean;
  /** When provided, renders error text below the control. */
  error?: string | false;
  children: React.ReactNode;
}

/**
 * Label + optional description + control slot + optional error text.
 * Matches the Figma FieldGroup primitive used across every form section.
 */
const FieldGroup: React.FC<FieldGroupProps> = ({
  label,
  labelVariant = "body2",
  description,
  required,
  error,
  children,
}) => (
  <FormControl error={!!error} fullWidth>
    <Stack gap={2}>
      <Box>
        <Typography variant={labelVariant} component="span">
          {label}
        </Typography>
        {required && (
          <Typography component="span" variant={labelVariant} color="error.main">
            {" "}
            *
          </Typography>
        )}
        {description && (
          <Typography variant="caption" color="text.secondary" component="p" lineHeight="143%">
            {description}
          </Typography>
        )}
      </Box>
      {children}
      {error && (
        <Typography variant="caption" color="error.main">
          {error}
        </Typography>
      )}
    </Stack>
  </FormControl>
);

export default FieldGroup;
